import { TelefoneComTipoFields } from 'app/modules/apps/shared/telefone/TelefoneComTipoFields'
import { opcaoTipoTelefone } from 'app/modules/apps/shared/telefone/tipoTelefone'
import { TipoLogradouroPaisFields } from 'app/modules/apps/shared/endereco/TipoLogradouroPaisFields'
import {
  dtoTipoLogradouroPais,
  valoresIniciaisTipoLogradouroPais,
} from 'app/modules/apps/shared/endereco/tipoLogradouroPais'
import { FC, FormEvent, useEffect, useMemo, useState } from 'react'
import { DocumentosPessoaForm } from 'app/modules/apps/shared/documentos-pessoa/DocumentosPessoaForm'
import { IdentificadoresPessoaFields } from 'app/modules/apps/shared/documentos-pessoa/IdentificadoresPessoaFields'
import { DocumentoPessoa } from 'app/modules/apps/shared/documentos-pessoa/_models'
import {
  dtoDocumentoEstrangeiro,
  temDocumentoEstrangeiro,
  valoresIniciaisIdentificadores,
} from 'app/modules/apps/shared/documentos-pessoa/identificadores'
import { documentosFuncionarioRequests } from 'app/modules/apps/funcionarios/funcionarios-list/core/_requests'
import { setNestedObjectValues, useFormik } from 'formik'
import { profissionalSchema } from './validation/profissionalSchema'
import { MedicoDtoCreate, MedicoDtoUpdate } from '../../core/_models'
import {
  createProfissionalDeSaude,
  getConselhos,
  updateProfissionalDeSaude,
} from '../../core/_requests'
import { ConselhosModal } from './ConselhosModal'
import {
  apenasDigitos,
  VinculoType,
  GenderType,
  RacaType,
  GeneroType,
  showAlert,
  applyApiFieldErrors,
  showError,
  Permission,
  OptionsHelper,
  MaskType,
  IconPaths,
  IconSize,
  ButtonType,
} from '_metronic/helpers'
import { useAuth } from 'app/modules/auth'
import { isVinculoMedicoAtivo } from 'app/modules/auth/core/vinculos'
import {
  Button,
  ButtonIcon,
  coletarMensagensErro,
  CustomAccordion,
  FetchState,
  FormDateInput,
  FormInput,
  FormSelect,
  FormTextArea,
  IOption,
  ListLoading,
  LoadingIndicator,
  useModal,
} from 'app/components'
import { useT } from '_metronic/i18n/Metronici18n'
import { isConselhoMedicina } from 'app/modules/apps/admin/profissionais-saude/profissional-saude/core/_conselho'
import {
  EnderecoDtoCreate,
  EnderecoList,
} from 'app/modules/apps/empresa/empresas-list/core/_models'
import { FuncionarioDtoDadosAdicionais } from 'app/modules/apps/funcionarios/funcionarios-list/core/_models'
import { getEstadoByUf } from 'app/modules/apps/atendimento_medicos/atendimentos-medico-list/core/_requests'
import { getGenerosByName, getRacasByName } from '_metronic/helpers/crud-helper/_request'
import { UsuarioDtoVinculo } from 'app/modules/apps/admin/usuarios/usuarios-list/core/_models'
import {
  DadosAdicionaisProfissionalFields,
  dtoDadosAdicionaisProfissional,
  valoresIniciaisDadosAdicionaisProfissional,
} from 'app/modules/apps/funcionarios/funcionarios-list/components/modal/DadosAdicionaisProfissionalFields'

export const ProfissionalDeSaudeModal: FC = () => {
  const { currentUser } = useAuth()
  const { closeModal, fetchStates, showModal } = useModal()
  const { t } = useT()

  const { data: usuario } = (fetchStates['usuario'] || {}) as FetchState<UsuarioDtoVinculo>

  const { data: endereco } = (fetchStates['endereco'] || {}) as FetchState<EnderecoList>

  const [showEndereco, setShowEndereco] = useState<boolean>(false)

  const medicoVinculo = usuario?.vinculos?.find(isVinculoMedicoAtivo)
  // Documentos são da pessoa: qualquer vínculo de funcionário serve de dono da lista.
  const vinculoFuncionario = medicoVinculo || usuario?.vinculos?.find((v) => !v.paciente)

  const [documentosLista, setDocumentosLista] = useState<DocumentoPessoa[]>([])
  const documentoEstrangeiroNaLista = temDocumentoEstrangeiro(documentosLista)

  const initialValues = {
    funcionario: {
      usuarioId: usuario?.id,
      primeiroNome: usuario?.pessoa?.primeiroNome || '',
      sobreNome: usuario?.pessoa?.sobreNome || '',
      nomeSocial: usuario?.pessoa?.nomeSocial || '',
      ...valoresIniciaisIdentificadores(usuario?.pessoa?.cpf, usuario?.pessoa?.cns),
      justificativa: '',
      vinculo: undefined as IOption<VinculoType> | undefined,
      conselho: medicoVinculo?.conselho
        ? {
            label: `${medicoVinculo.conselho.sigla} - ${medicoVinculo.conselho.nome}`,
            value: medicoVinculo.conselho.id,
          }
        : undefined,

      uf: undefined as IOption<string> | undefined,
      telefone: usuario?.pessoa?.telefone || '',
      tipoTelefone: opcaoTipoTelefone(t, usuario?.pessoa?.tipoTelefone),
      sexo: usuario
        ? {
            label: usuario.pessoa?.sexo === GenderType.Feminino ? 'Feminino' : 'Masculino',
            value: usuario.pessoa?.sexo,
          }
        : (undefined as IOption<GenderType> | undefined),
      nascimento: usuario?.pessoa?.dataNascimento || '',
      crm: medicoVinculo?.crm?.match(/\d+/)?.[0] || '',

      email: usuario?.email || '',
      rqe: medicoVinculo?.rqe || '',
      especialidades: [],
      raca: undefined as IOption<RacaType> | undefined,
      genero: undefined as IOption<GeneroType> | undefined,
      nacionalidade: medicoVinculo?.dadosAdicionais?.nacionalidade
        ? {
            label: medicoVinculo?.dadosAdicionais?.nacionalidade.descricao,
            value: medicoVinculo?.dadosAdicionais?.nacionalidade.id,
          }
        : undefined,
      ...valoresIniciaisDadosAdicionaisProfissional(medicoVinculo?.dadosAdicionais),
    },

    empresas: [],

    // endereço
    endereco: {
      cep: endereco?.cep || '',
      logradouro: endereco?.logradouro || '',
      numero: endereco?.numero || '',
      complemento: endereco?.complemento || '',
      bairro: endereco?.bairro || '',
      cidade: endereco?.cidade || '',
      uf: undefined as IOption<string> | undefined,
      ...valoresIniciaisTipoLogradouroPais(endereco),
    },
  }

  const formik = useFormik({
    initialValues,
    validationSchema: useMemo(
      () =>
        profissionalSchema(
          t,
          showEndereco,
          !!usuario,
          documentoEstrangeiroNaLista,
          initialValues.funcionario.cpf,
          initialValues.funcionario.cns
        ),
      [
        t,
        showEndereco,
        usuario,
        documentoEstrangeiroNaLista,
        initialValues.funcionario.cpf,
        initialValues.funcionario.cns,
      ]
    ),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const endere: EnderecoDtoCreate = {
          tipo: 1,
          cep: values.endereco.cep,
          logradouro: values.endereco.logradouro,
          numero: values.endereco.numero,
          complemento: values.endereco.complemento ? values.endereco.complemento : null,
          bairro: values.endereco.bairro,
          cidade: values.endereco.cidade,
          uf: values.endereco.uf?.value as string,
          ...dtoTipoLogradouroPais(values.endereco),
        }
        const dadosAdicionais: FuncionarioDtoDadosAdicionais = {
          genero: values.funcionario.genero?.value,
          nacionalidade: values.funcionario.nacionalidade?.value,
          raca: values.funcionario.raca?.value,
          ...dtoDadosAdicionaisProfissional(values.funcionario),
        }
        if (usuario) {
          const documentoAlterado =
            apenasDigitos(values.funcionario.cpf) !==
              apenasDigitos(initialValues.funcionario.cpf) ||
            apenasDigitos(values.funcionario.cns) !== apenasDigitos(initialValues.funcionario.cns)

          const data: MedicoDtoUpdate = {
            id: Number(usuario.pessoa?.id),
            email: values.funcionario.email,
            rqe: isConselhoMedicina(values.funcionario.conselho)
              ? values.funcionario.rqe || undefined
              : undefined,
            pessoa: {
              id: Number(usuario.pessoa?.id),
              nascimento: values.funcionario.nascimento,
              telefone: values.funcionario.telefone || undefined,
              tipoTelefone: values.funcionario.tipoTelefone?.value,
              cpf: values.funcionario.cpf || undefined,
              cns: values.funcionario.cns || undefined,
              ...dtoDocumentoEstrangeiro(values.funcionario, documentoEstrangeiroNaLista),
              sexo: values.funcionario.sexo?.value as GenderType,
              primeiroNome: values.funcionario.primeiroNome,
              sobreNome: values.funcionario.sobreNome,
              nomeSocial: values.funcionario.nomeSocial || undefined,
              justificativa: documentoAlterado
                ? values.funcionario.justificativa || undefined
                : undefined,
            },
            uf: values.funcionario.uf?.value as string,
            crm: values.funcionario.crm,
            endereco: showEndereco ? endere : undefined,
            conselho: values.funcionario.conselho?.value || undefined,
            dadosAdicionais,
          }
          await updateProfissionalDeSaude(data)
        } else {
          const profissional: MedicoDtoCreate = {
            primeiroNome: values.funcionario.primeiroNome,
            sobreNome: values.funcionario.sobreNome,
            nomeSocial: values.funcionario.nomeSocial || undefined,
            cpf: values.funcionario.cpf || undefined,
            cns: values.funcionario.cns || undefined,
            email: values.funcionario.email,
            telefone: values.funcionario.telefone || undefined,
            tipoTelefone: values.funcionario.tipoTelefone?.value,
            ...dtoDocumentoEstrangeiro(values.funcionario, false),
            sexo: values.funcionario.sexo?.value as GenderType,
            nascimento: values.funcionario.nascimento,
            crm: values.funcionario.crm,
            rqe: isConselhoMedicina(values.funcionario.conselho)
              ? values.funcionario.rqe || undefined
              : undefined,
            uf: values.funcionario.uf?.value as string,
            endereco: showEndereco ? endere : undefined,
            especialidades: values.funcionario.especialidades
              ? values.funcionario.especialidades.map(({ value }) => value as number)
              : [],
            empresas: values.empresas.map(({ value }) => value as number),
            vinculo: values.funcionario.vinculo?.value || undefined,
            conselho: Number(values.funcionario.conselho?.value),
            dadosAdicionais,
          }
          await createProfissionalDeSaude(profissional)
        }

        await showAlert({
          title: 'Sucesso',
          text: `Profissional de saúde ${usuario ? 'editado' : 'criado'} com sucesso`,
          icon: 'success',
        })

        closeModal()
      } catch (error) {
        const temOutroErro = applyApiFieldErrors(
          error,
          (campo, mensagem) => formik.setFieldError(`funcionario.${campo}`, mensagem),
          ['cpf', 'cns', 'crm', 'uf', 'email']
        )
        if (temOutroErro) showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  const { setFieldValue } = formik

  useEffect(() => {
    const getEstadoEndereco = async () => {
      const ufEnd = await getEstadoByUf(endereco?.uf as string)
      setFieldValue('endereco.uf', { label: ufEnd.descricao, value: ufEnd.sigla })
    }

    const getEstadoUsuario = async () => {
      if (medicoVinculo) {
        const ufCrm = await getEstadoByUf(medicoVinculo?.crm?.match(/[A-Z]+/)?.[0] || '')
        setFieldValue('funcionario.uf', { label: ufCrm.descricao, value: ufCrm.sigla })
      }
    }

    const fetchData = async () => {
      if (medicoVinculo?.dadosAdicionais?.genero) {
        const genero = await getGenerosByName(medicoVinculo?.dadosAdicionais?.genero)
        setFieldValue('funcionario.genero', { label: genero.descricao, value: genero.name })
      }
      if (medicoVinculo?.dadosAdicionais?.raca) {
        const raca = await getRacasByName(medicoVinculo?.dadosAdicionais?.raca)
        setFieldValue('funcionario.raca', { label: raca.descricao, value: raca.name })
      }
    }

    if (endereco) getEstadoEndereco()
    getEstadoUsuario()
    fetchData()
  }, [endereco, medicoVinculo, setFieldValue])

  const showVinculo =
    currentUser?.grupo?.nome === Permission.SuperAdmin ||
    currentUser?.grupo?.nome === Permission.SuperMedico

  const documentoAlterado =
    !!usuario &&
    (apenasDigitos(formik.values.funcionario.cpf) !==
      apenasDigitos(initialValues.funcionario.cpf) ||
      apenasDigitos(formik.values.funcionario.cns) !== apenasDigitos(initialValues.funcionario.cns))

  const openConselhosModal = () => {
    showModal({
      title: 'Gerenciar Conselhos',
      content: <ConselhosModal />,
      fetchers: {
        conselhos: () => getConselhos(),
      },
    })
  }

  /**
   * Sem isso o submit vira um no-op silencioso quando o campo reprovado não
   * está renderizado (ex.: CEP com a seção de endereço fechada): o Formik
   * bloqueia o envio e nenhum `ErrorLabel` aparece em tela.
   */
  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const errors = await formik.validateForm()
    const mensagens = coletarMensagensErro(errors)

    if (mensagens.length > 0) {
      formik.setTouched(setNestedObjectValues(errors, true))
      showAlert({
        title: 'Verifique o formulário',
        icon: 'warning',
        html: `<ul class='text-start'>${mensagens.map((msg) => `<li>${msg}</li>`).join('')}</ul>`,
      })
      return
    }

    formik.handleSubmit(event)
  }

  return (
    <form onSubmit={handleSubmit} noValidate>
      {!usuario && (
        <>
          <div className='row mb-3'>
            <FormSelect
              formik={formik}
              name='empresas'
              entity='empresa'
              fetchOptions={OptionsHelper.getOptionsEmpresas}
              isRequired
              isMulti
            />
          </div>
          <FormSelect
            formik={formik}
            entity='especialidade'
            name='funcionario.especialidades'
            fetchOptions={OptionsHelper.getOptionsEspecialidades}
            className='mb-3'
            isMulti
          />
          {showVinculo && (
            <FormSelect
              formik={formik}
              entity='vinculo'
              name='funcionario.vinculo'
              fetchOptions={OptionsHelper.getOptionsTiposVinculos}
              className='mb-3'
              isDisabled={formik.isSubmitting}
            />
          )}
        </>
      )}

      <div className='row mb-3'>
        <div className='col-md-6'>
          <FormInput
            formik={formik}
            entity='primeiroNome'
            name='funcionario.primeiroNome'
            isRequired
          />
        </div>
        <div className='col-md-6'>
          <FormInput formik={formik} name='funcionario.sobreNome' entity='sobrenome' isRequired />
        </div>
      </div>
      <FormInput
        formik={formik}
        name='funcionario.nomeSocial'
        entity='nome_social'
        className='mb-3'
        isDisabled={formik.isSubmitting}
      />
      <IdentificadoresPessoaFields
        formik={formik}
        prefixo='funcionario.'
        cpf={formik.values.funcionario.cpf}
        cns={formik.values.funcionario.cns}
        documentoEstrangeiroNaLista={documentoEstrangeiroNaLista}
        idPrefix='profissional'
      />
      {documentoAlterado && (
        <FormTextArea
          formik={formik}
          name='funcionario.justificativa'
          entity='justificativa_cpf_cns'
          placeholder='Descreva o motivo da alteração do CPF/CNS'
          className='mb-3'
          isRequired
        />
      )}
      <div className='row mb-3'>
        <div className='col-md-6'>
          <TelefoneComTipoFields formik={formik} prefixo='funcionario.' idPrefix='profissional' />
        </div>
        <div className='col-md-6'>
          <FormInput formik={formik} name='funcionario.email' entity='email' isRequired />
        </div>
      </div>

      <div className='row mb-3'>
        <div className='col-md-6'>
          <div className='d-flex align-items-end mb-3'>
            <FormSelect
              formik={formik}
              name='funcionario.conselho'
              fetchOptions={OptionsHelper.getOptionsConselhos}
              className='flex-grow-1'
              isDisabled={formik.isSubmitting}
              entity='conselho'
              isRequired
            />
            <ButtonIcon
              icon={IconPaths.Gear}
              iconSize={IconSize.Small}
              onClick={openConselhosModal}
              disabled={formik.isSubmitting}
            />
          </div>
        </div>
        {isConselhoMedicina(formik.values.funcionario.conselho) && (
          <div className='col-md-6'>
            <FormInput formik={formik} name='funcionario.rqe' entity='rqe' />
          </div>
        )}
      </div>

      <div className='row mb-3'>
        <div className='col-md-6'>
          <FormInput formik={formik} name='funcionario.crm' entity='registro_conselho' isRequired />
        </div>
        <div className='col-md-6'>
          <FormSelect
            formik={formik}
            name='funcionario.uf'
            entity='estado'
            fetchOptions={OptionsHelper.getOptionsEstadosUf}
            isClearable={false}
            isDisabled={formik.isSubmitting}
            isRequired
          />
        </div>
      </div>

      <div className='row mb-3'>
        <div className='col-md-6'>
          <FormSelect
            formik={formik}
            entity='sexo'
            name='funcionario.sexo'
            options={OptionsHelper.generos}
            isClearable={false}
            isDisabled={formik.isSubmitting}
            isRequired
          />
        </div>
        <div className='col-md-6'>
          <FormDateInput
            formik={formik}
            name='funcionario.nascimento'
            entity='data_nascimento'
            maxDate={new Date()}
            isRequired
          />
        </div>
      </div>

      <div className='row my-5'>
        <h2>{t('documento_pessoa.titulo')}</h2>
      </div>
      <DocumentosPessoaForm
        ownerId={vinculoFuncionario?.id ? Number(vinculoFuncionario.id) : undefined}
        recurso='funcionario'
        requests={documentosFuncionarioRequests}
        onChange={setDocumentosLista}
      />

      <CustomAccordion title={t('dado_adicional.plural')}>
        <div className='row my-5'>
          <h2>{t('informacao_adicional.plural')}</h2>
        </div>

        <div className='row mb-3'>
          <div className='col-md-6'>
            <FormSelect
              formik={formik}
              name='funcionario.raca'
              entity='raca'
              fetchOptions={OptionsHelper.getOptionsRacas}
              isDisabled={formik.isSubmitting}
            />
          </div>
          <div className='col-md-6'>
            <FormSelect
              formik={formik}
              name='funcionario.genero'
              entity='genero'
              fetchOptions={OptionsHelper.getOptionsGeneros}
              isDisabled={formik.isSubmitting}
            />
          </div>
        </div>
        <FormSelect
          formik={formik}
          name='funcionario.nacionalidade'
          entity='nacionalidade'
          fetchOptions={OptionsHelper.getOptionsNacionalidades}
          isDisabled={formik.isSubmitting}
          className='mb-3'
        />
        <DadosAdicionaisProfissionalFields
          formik={formik}
          estadoNascimentoInicial={medicoVinculo?.dadosAdicionais?.estadoNascimento}
          idPrefix='profissional'
        />
      </CustomAccordion>

      {showEndereco && (
        <>
          <TipoLogradouroPaisFields
            formik={formik}
            prefixo='endereco.'
            novo={!endereco}
            idPrefix='profissional-endereco'
          />
          <div className='row mb-3'>
            <div className='col-md-8'>
              <FormInput
                formik={formik}
                name='endereco.logradouro'
                entity='logradouro'
                isRequired
              />
            </div>
            <div className='col-md-4'>
              <FormInput formik={formik} entity='numero' name='endereco.numero' isRequired />
            </div>
          </div>
          <div className='row mb-3'>
            <div className='col-md-8'>
              <FormInput formik={formik} entity='complemento' name='endereco.complemento' />
            </div>
            <div className='col-md-4'>
              <FormInput
                formik={formik}
                entity='cep'
                name='endereco.cep'
                mask={MaskType.CEP}
                isRequired
              />
            </div>
          </div>
          <div className='row mb-3'>
            <div className='col-md-8'>
              <FormInput formik={formik} entity='bairro' name='endereco.bairro' isRequired />
            </div>
            <div className='col-md-4'>
              <FormInput formik={formik} entity='cidade' name='endereco.cidade' isRequired />
            </div>
          </div>

          <FormSelect
            formik={formik}
            entity='estado'
            name='endereco.uf'
            fetchOptions={OptionsHelper.getOptionsEstadosUf}
            isClearable={false}
            isDisabled={formik.isSubmitting}
            isRequired
          />
        </>
      )}

      <div className='d-flex flex-end my-4'>
        <Button
          className='btn-primary'
          onClick={() => setShowEndereco((prev) => !prev)}
          disabled={formik.isSubmitting}
          size='btn-sm'
        >
          {endereco
            ? showEndereco
              ? 'Esconder Endereço'
              : 'Ver Endereço'
            : showEndereco
            ? 'Remover Endereço'
            : 'Adicionar Endereço'}
        </Button>
      </div>

      <div className='d-flex justify-content-center mt-8'>
        <Button
          type={ButtonType.Reset}
          onClick={closeModal}
          className='btn-secondary me-3'
          disabled={formik.isSubmitting}
        >
          {t('common.cancel')}
        </Button>

        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : t('common.save')}
        </Button>
      </div>
      {formik.isSubmitting && <ListLoading />}
    </form>
  )
}
